import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL + "/api/gaji"; 

export const postGaji = async (data) => {
  const response = await axios.post(API_URL, data);
  return response.data;
};

export const getGajiKaryawan = async (id,periode) => {
  const response = await axios.get(`${API_URL}/detail/karyawan?gji_id_karyawan=${id}&gji_periode=${periode}`);
  return response.data;
};

export const downloadGajiPdf = async (employeeId, periode) => {
  const url = `${process.env.REACT_APP_API_URL}/api/report/users/${employeeId}?periode=${periode}`;
  return await axios.get(url, {
    responseType: 'blob',
  });
};